import React from "react";
const IconEdit = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="m11.381 5.08-7.7 7.7-.933 4.468 4.468-.932 7.634-7.634M11.38 5.08l3.1-3.1 3.535 3.536-3.166 3.166M11.38 5.08l3.469 3.602"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconEdit;
